<div class="asepticModalHead  border-0 text-center justify-content-between ">
  <div class="modal-title w-100 sticky d-flex justify-content-between align-items-center">
    <div class="col p-0 d-flex justify-content-between align-items-center">      
      <div class="col p-0 justify-content-between align-items-lg-center align-items-md-start">
        <div class="col mt-3">
          
          <div class="row align-items-center justify-content-between">
            <div class="col">
              <div class="row align-items-center mb-2 justify-content-between">
                <div class="col d-flex section-title p-0 font18">{{selectedward | translate | labelSanitizer}} / {{selecteddept | translate}}</div>
              </div>
 
              <div class="row">
                <div class="date-span">{{dateString}}</div>
                
              </div>
            </div>
            
          </div>
        </div>
        <button type="button" class="d-flex close closeIcon" (click)="modalRef.hide()"></button>
      </div>
    </div>
  </div>
</div>
